/**
 * YvCalendar
 * ======================================
 */

 const DAYS = ".yv-calendar__day.is-open";
 const TABS = ".yv-calendar__actual-day";
 const NEXTTAB = ".js-YvCalendarNextTab";
 const PREVTAB = ".js-YvCalendarPrevTab";
 const NEXTTAB_CLASS = "is-next";
 const TAB_OPEN_CLASS = "is-open";
 const DAY_OPEN_CLASS = "is-actual";

 class YvCalendar {
   constructor() {
     this.days = document.querySelectorAll(DAYS);
     this.tabs = document.querySelectorAll(TABS);
     this.next_tab_btns = document.querySelectorAll(NEXTTAB);
     this.prev_tab_btns = document.querySelectorAll(PREVTAB);

     if (!this.days) {
       return false;
     }

     this.days.forEach((el) => {
      el.addEventListener("click", this.openDay);
    });

    this.next_tab_btns.forEach((el) => {
      el.addEventListener("click", this.nextSlide);
    });

    this.prev_tab_btns.forEach((el) => {
      el.addEventListener("click", this.prevSlide);
    });
   }

   nextSlide = (e) => {
    const el = e.currentTarget;
    const card = el.closest('.yv-calendar__actual-day')

    card.classList.add(NEXTTAB_CLASS)
   }

   prevSlide = (e) => {
    const el = e.currentTarget;
    const card = el.closest('.yv-calendar__actual-day')

    card.classList.remove(NEXTTAB_CLASS)
   }

   openDay = (e) => {
     const el = e.currentTarget;
     const targetTab = document.querySelector(el.getAttribute('data-open'))

     this.tabs.forEach((tab) => {
      tab.classList.remove(TAB_OPEN_CLASS)
     })

     this.days.forEach((day) => {
      day.classList.remove(DAY_OPEN_CLASS)
     })

     el.classList.add(DAY_OPEN_CLASS)
     targetTab.classList.add(TAB_OPEN_CLASS)

    document.querySelector('.yv-calendar__actual').scrollIntoView(
      {behavior: "smooth", block: "center"}
    )

     e.preventDefault();
   };
 }

 new YvCalendar();
